import React , {useState, useEffect}from 'react';
import {
    Button, InputGroup, InputGroupText,
    Card,Badge,Spinner,Table, Modal, ModalBody,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Form,
    Input,
    Row,
    Col,
    Container,
    ModalHeader,
    ModalFooter,
  } from "reactstrap";
  import ReactTable from "components/ReactTable/ReactTable.js";
  import CreateVInfo from './CreateVInfo'
  import { useSelector , useDispatch} from 'react-redux'
  import Select from "react-select";
  import {customStyles} from '../../helpers/mycomps'
  import Switch from "react-bootstrap-switch";
  import TimePicker from 'react-time-picker';
  import 'react-time-picker/dist/TimePicker.css';
  import 'react-clock/dist/Clock.css';
  import { profileFetch } from "../../actions/actions";
  import { connect } from 'react-redux'
  

  function Disclaimer(props) {
        const [showProcessing , setShowProcessing] = useState(false)
        const storarea  = useSelector(state => state.areaStore.areaData).map((x, key) => {
    
    return {
        key : key,
      label :x.cityName.en  , value : x.cityCode, 
      labelfr : x.cityName.fr, labelar : x.cityName.ar,
      areas : x.area
    }
        })
        const storprofile  = useSelector(state => state.profileStore.profileData)

        const [city, setCity] = useState({cityCode : "", en : "", fr : "", ar : ""})
        const [shstore, setShstore] = useState(false)
        const [showSite, setShowSite] = useState(false)
        const [sites, setSites] = useState([])
        const [arealist, setArealist] = useState([])
    

        const [tenant, setTenant] = useState({
            tuid : props.user.tuid,
            paymentmodes : [
                {
                    modename : {en : "Cash", fr : "Espèces", ar :"نقدي", isval : true}
                },
                {
                    modename : {en : "Debit Card", fr : "Carte de débit", ar :"بطاقة ائتمان", isval : true}
                },
                {
                    modename : {en : "Credit Card", fr : "Carte de crédit", ar :"بطاقة إئتمان", isval : true}
                },
                {
                    modename : {en : "Cheque", fr : "Cheque", ar :"يفحص", isval : true}
                }
            ],
            disclaimer : {en : "", fr : "", ar :""},
            operatingHours : [
                {
                    day : {en : "Monday", fr : "Lundi", ar :"الاثنين"} ,
                    otime : "08:00",
                    ctime :  "20:00"
                },
                {
                    day : {en : "Tuesday", fr : "Mardi", ar :"يوم الثلاثاء"} ,
                    otime : "08:00",
                    ctime : "20:00"
                },
                {
                    day : {en : "Wednesday", fr : "Mercredi", ar :"الأربعاء"} ,
                    otime : "08:00",
                    ctime : "20:00"
                },
                {
                    day : {en : "Thursday", fr : "Jeudi", ar :"يوم الخميس"} ,
                    otime :"08:00",
                    ctime : "20:00"
                },
                {
                    day : {en : "Friday", fr : "Vendredi", ar :"جمعة"} ,
                    otime : "08:00",
                    ctime :"20:00"
                },
                {
                    day : {en : "Saturday", fr : "Samedi", ar :"السبت"} ,
                    otime : "08:00",
                    ctime : "20:00"
                },
                {
                    day : {en : "Sunday", fr : "Dimanche", ar :"الأحد"} ,
                    otime : "08:00",
                    ctime :  "20:00"
                },
            ],
            faq : [
                {
                    qno: "",
                    question : {en : "", fr : "", ar :""},
                    answer : {en : "", fr : "", ar :""}
                }
            ],
            deliveryarea : [{areaCode : "", en : "", fr : "", ar : ""}],
            sites : []
        })    


        const errorhandler = (error) => {
            try{
              if(error.response.status === 401){
                props.swal("Unauthorized, please login again.").then(t => {
                    props.history.push(`/auth/login`)
                })   
              }else{
                props.swal(error.response.data.message)
              }
            } catch(e){
              props.swal("error processing request at this time, please contact support.")
            } 
          
          }
        
        const setvals = () =>{
            try{
                setTenant({...tenant , disclaimer : storprofile[0].disclaimer, operatingHours : storprofile[0].operatingHours 
                    , paymentmodes: storprofile[0].paymentmodes, deliveryarea : storprofile[0].deliveryarea, sites : storprofile[0]?.sites  })
            }catch(e){
                setTenant({
                    tuid : props.user.tuid,
                    paymentmodes : [
                        {
                            modename : {en : "Cash", fr : "Espèces", ar :"نقدي", isval : true}
                        },
                        {
                            modename : {en : "Debit Card", fr : "Carte de débit", ar :"بطاقة ائتمان", isval : true}
                        },
                        {
                            modename : {en : "Credit Card", fr : "Carte de crédit", ar :"بطاقة إئتمان", isval : true}
                        },
                        {
                            modename : {en : "Cheque", fr : "Cheque", ar :"يفحص", isval : true}
                        }
                    ],
                    disclaimer : {en : "", fr : "", ar :""},
                    operatingHours : [
                        {
                            day : {en : "Monday", fr : "Lundi", ar :"الاثنين"} ,
                            otime : "08:00",
                            ctime :  "20:00"
                        },
                        {
                            day : {en : "Tuesday", fr : "Mardi", ar :"يوم الثلاثاء"} ,
                            otime : "08:00",
                            ctime : "20:00"
                        },
                        {
                            day : {en : "Wednesday", fr : "Mercredi", ar :"الأربعاء"} ,
                            otime : "08:00",
                            ctime : "20:00"
                        },
                        {
                            day : {en : "Thursday", fr : "Jeudi", ar :"يوم الخميس"} ,
                            otime :"08:00",
                            ctime : "20:00"
                        },
                        {
                            day : {en : "Friday", fr : "Vendredi", ar :"جمعة"} ,
                            otime : "08:00",
                            ctime :"20:00"
                        },
                        {
                            day : {en : "Saturday", fr : "Samedi", ar :"السبت"} ,
                            otime : "08:00",
                            ctime : "20:00"
                        },
                        {
                            day : {en : "Sunday", fr : "Dimanche", ar :"الأحد"} ,
                            otime : "08:00",
                            ctime :  "20:00"
                        },
                    ],
                    faq : [
                        {
                            qno: "",
                            question : {en : "", fr : "", ar :""},
                            answer : {en : "", fr : "", ar :""}
                        }
                    ],
                    deliveryarea : [{areaCode : "", en : "", fr : "", ar : ""}]
                })
            }
                
            
        }

       const changetime = (day,type, value) => {
             //   console.log(day + type,value)
             let ten = tenant
                ten.operatingHours.find(g => g.day.en === day)[type] = value
                //timee[type] = value
                //setTenant({...tenant, operatingHours : timee})
                setTenant({...tenant, operatingHours : ten.operatingHours})
          
        }

        const changetimets = (day,type, value) => {
            //   console.log(day + type,value)
            let ten = tenant
               ten.operatingHours.map(g => {
                g.otime ="00:00"
                g.ctime = "24:59"
               })
               //timee[type] = value
               //setTenant({...tenant, operatingHours : timee})
               setTenant({...tenant, operatingHours : ten.operatingHours})
          

       }

       const addarea = (t, data) => {
            let lxdata = []
            if(tenant.deliveryarea.find(da => da.areaCode === t.areaCode)){
           return
            }else{
                
               let da = {areaCode : t.areaCode, en : t.en, fr : t.fr, ar : t.ar }
               let delarea = tenant.deliveryarea
           
               delarea.push(da)
               
               data.map(g => {
                if(g.areaCode === t.areaCode) {
                    g.action = "Added"
                }
                lxdata.push(g)
               })
               setArealist(lxdata)
               
            }
            console.log(data)
       }    

       const areaset = () => {
        return (
            <Modal isOpen={shstore} style={{marginTop : -30}}>
                <ModalBody>
                    <Row>
                        <Col>
                            <Button size="sm" onClick={x => setShstore(false)}>Close</Button>
                        </Col>
                        <Col>
                        <Select options={storarea} styles={customStyles} 
                                   value={{label : city.en + ' ' + city.ar, value : city.cityCode}} 
                                   onChange={e=> {setCity({cityCode: e.value, en: e.label, fr: e.labelfr, ar: e.labelar});
                                         let data = e.areas.map(t => {
                                            let datax = tenant.deliveryarea.find(f =>  f.areaCode.includes(t.areaCode))
                                            return {
                                              ...t, value : t.areaCode, label: t.en, labelfr: t.fr, labelar : t.ar ,
                                              action :  ( <div className="actions-right">
                                               {datax ? <h6>Listed</h6> : <Button className="actions-right" size="sm" color="warning" onClick={m => addarea(t, data)}>Add</Button>} 
                                              </div>)
                                            }
                                          })
                                          setArealist(data);  
                                          //setArea({areaCode : "", en : "", fr : "", ar : ""})      
                                        }}
                                   />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Table>
                                <tbody>
                                    {
                                     arealist.map((h , key) => {
                                        return(
                                            <tr key={key}>
                                            <td>{h.areaCode} - {h.label} - {h.labelar}</td>
                                            <td>{h.action}</td>
                                        </tr>
                                        )
                                       
                                     })
                                    }
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        )
       }


       const showsites = () => {
        let xsi = tenant?.sites
        
        return (
            <Modal isOpen={showSite} style={{marginTop : -30}}>
                <ModalHeader toggle={t => setShowSite(!showSite)} style={{fontSize : "0.6rem"}}>Add Sites for {storprofile[0]?.tname?.en}</ModalHeader>
                <ModalBody >
                    <Row style={{marginTop : "10px"}}>
                        <Col><Input type='text' maxLength={200} placeholder='Site ID' value={sites?.siteCode} readOnly /></Col>
                    </Row>
                    <Row style={{marginTop : "10px"}}>
                        <Col><Input type='text' maxLength={200} placeholder='Site Name EN' value={sites?.en} onChange={m => setSites({...sites, en : m.target.value, siteCode : tenant?.sites?.length + 1 })} /></Col>
                    </Row>
                    <Row style={{marginTop : "10px"}}>
                        <Col><Input type='text' maxLength={200} placeholder='اسم الموقع AR' value={sites?.ar} onChange={m => setSites({...sites, ar : m.target.value })} /></Col>
                    </Row>
                    <Row style={{marginTop : "10px"}}>
                        <Col md="6"><Input type='text' maxLength={20} placeholder='Site Phone' value={sites?.sitephn} onChange={m => setSites({...sites, sitephn : m.target.value })} /></Col>
                    </Row>
                   <Row style={{marginTop : "10px"}}>
                            <Col><Input type='text' maxLength={200} placeholder='Street Address' value={sites?.siteSa} onChange={m => setSites({...sites, siteSa : m.target.value })} /></Col>
                   </Row>
                    <Row style={{marginTop : "10px"}}>
                        <Col><Select options={storarea} styles={customStyles} 
                                   
                                   placeholder="City"
                                   onChange={e=> {
                                        setCity({cityCode: e.value, en: e.label, fr: e.labelfr, ar: e.labelar})
                                        setSites({...sites, cityCode : e.value , city : {cityCode: e.value, en: e.label, fr: e.labelfr, ar: e.labelar}})
                                        let data = e.areas.filter(mm => mm.cityCode === e.cityCode).map(t => {
                                            return {
                                              ...t, value : t.areaCode, label: t.en, labelfr: t.fr, labelar : t.ar
                                              
                                            }
                                          })
                                          setArealist(data);  
                                    }}
                                   /></Col>
                        <Col>
                        <Select options={arealist} styles={customStyles} 
                                  placeholder="Area"
                                  onChange={e=> {
                                    setSites({...sites, areaCode : e.value , areas : e })
                                    
                                        }}
                                   />
                        </Col>

                    </Row>
                </ModalBody>
                <ModalFooter>
                    <i className="fa fa-floppy-o fa-2x" style={{float : "right", paddingRight : 20, cursor : "pointer"}} aria-hidden="true" onClick={o => {closesite(o) }} />
                </ModalFooter>    
            </Modal>
        )
       }

       const closesite = (e) => {
        e.preventDefault(); 
        setTenant({...tenant, sites : tenant?.sites?.length >= 1 ? [...tenant?.sites, sites] : [sites]})
        setSites({})
       }

       const cleararea = () => {
        setTenant({...tenant, deliveryarea : [{areaCode : "", en : "", fr : "", ar : ""}]})
       }

       const removearea = (x) => {
        console.log(x)
        let olddata = tenant.deliveryarea.filter(h => h.areaCode !== x.areaCode)
        setTenant({...tenant , deliveryarea : olddata})
       }

       const savedata = (type) => {
        
            if(type === "DN"){
                setShowProcessing(true)
                props.API.post(`ten/updatedn`, {tenant : tenant},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
                  props.swal(res.data.message)
                    setShowProcessing(false)
                  }).catch(function (error) {
                    setShowProcessing(false)
                    errorhandler(error)  
                  })
            }else if(type=== "WH"){
             
                setShowProcessing(true)
                props.API.post(`ten/updatewh`, {tenant : tenant},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
                    props.swal(res.data.message)
                    setShowProcessing(false)
                    window.location.reload(false)
                  }).catch(function (error) {
                    setShowProcessing(false)
                    errorhandler(error)
                     
                  })

            }else if(type=== "PM"){
       
                setShowProcessing(true)
                props.API.post(`ten/updatepm`, {tenant : tenant},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
                   props.swal(res.data.message)
                    setShowProcessing(false)
                    window.location.reload(false)
                  }).catch(function (error) {
                    setShowProcessing(false)
                    errorhandler(error)   
                  })
            }
            else if(type=== "DA"){
       
                setShowProcessing(true)
                props.API.post(`ten/updateca`, {tenant : tenant},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
                    props.swal(res.data.message)
                    setShowProcessing(false)
                    window.location.reload(false)
                  }).catch(function (error) {
                    setShowProcessing(false)
                   errorhandler(error) 
                  })
            }
            else if(type=== "SITES"){
                let xt = false
                tenant?.sites?.forEach(x => {
                    console.log(x)
                    if(!x?.city?.cityCode || !x?.areas?.areaCode){
                        props.swal("Site without city or area is not allowed.")    
                        xt = true
                    }   
                    
                })
                    if(!xt){
                        setShowProcessing(true)
                        props.API.post(`ten/updatesites`, {tenant : tenant},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
                            props.swal(res.data.message)
                            setShowProcessing(false)
                            window.location.reload(false)
                        }).catch(function (error) {
                            setShowProcessing(false)
                        errorhandler(error) 
                        })
                    }    
                        
                
            }
         //   dispatch(profileFetch(props.user.tuid))
       }

       const changepaymode = (data) => {
            let dataa = tenant.paymentmodes
            let val = dataa.find(x => x.modename.en === data.modename.en).modename.isval
            dataa.find(x => x.modename.en === data.modename.en).modename.isval = !val
          
            setTenant({...tenant, paymentmodes : dataa}) 
       }

       useEffect(()=> {
            setvals()
       }, [storprofile])


        
      const disarea = tenant.deliveryarea.map((da, key) => {
        try{
            if(da.en){
            return (
                <Badge color="primary" className="shadow" key={key} style={{fontSize : "1em"}}>{da.en}  &nbsp; <span className="shadow" style={{ color : "red", cursor : "pointer", borderRadius : "5px", textAlign : "center"}} onClick={g => removearea(da)}><b>x</b></span></Badge> 
            )}
        }catch(e){"No data available"}
        })

      const delsite = (ex) => {
            let ten = tenant
            let nsites = ten?.sites?.filter(t => t.siteCode !== ex.siteCode)
            console.log(nsites)
            setTenant({...tenant, sites: nsites})
            props.swal("Please save changes to keep them persistant in database.")
            setSites({})
      }  


        return (
            <div className='content'>
                  {showProcessing && props.Spin } 
                {showsites()}
                {areaset()}
                <Row>
                    <Col>
                        <Card>
                            <CardHeader><h6>Disclaimer Note for the tenant page  {' '}
                            <i className="fa fa-floppy-o fa-2x" style={{float : "right", paddingRight : 20, cursor : "pointer"}} aria-hidden="true" onClick={o => savedata("DN")}></i>
                            </h6></CardHeader>
                            <CardBody>
                                <Row>
                                    <Col><Input maxLength={100} type="textarea" value={tenant.disclaimer.en ? tenant.disclaimer.en : "" } onChange={m => setTenant({...tenant, disclaimer : {en : m.target.value, fr : tenant.disclaimer.fr , ar : tenant.disclaimer.ar }})}  /></Col>
                                    {/** <Col><Input maxLength={100} type="textarea" value={tenant.disclaimer.fr} onChange={m => setTenant({...tenant, disclaimer : {en : tenant.disclaimer.en, fr : m.target.value , ar : tenant.disclaimer.ar }})} /></Col> */}
                                    <Col><Input maxLength={100} type="textarea" value={tenant.disclaimer.ar ? tenant.disclaimer.ar : ""} onChange={m => setTenant({...tenant, disclaimer : {en : tenant.disclaimer.en, fr : tenant.disclaimer.fr , ar : m.target.value }})} /></Col>
                                </Row>
                                
                            </CardBody>
                        </Card>
                        <Card>
                            <CardHeader><h6>Working Hours {' '}<Badge onClick={t => changetimets()} color="primary">24/7</Badge>  
                            <i className="fa fa-floppy-o fa-2x" style={{float : "right", paddingRight : 20, cursor : "pointer"}} aria-hidden="true" onClick={o => savedata("WH")}></i></h6></CardHeader>
                            <CardBody>
                               
                                {tenant.operatingHours.map((x , key) => {
                                        return(
                                         
                                            <Row style={{border:  "1px solid lightgray", padding : 1, margin :1}} key={key}>
                                            <Col>    {x.day.en} {' '}</Col>
                                            <Col style={{border:  "1px solid lightgray"}}>Open  <TimePicker defaultValue={'8:00'} value={x.otime} onChange={g => changetime(x.day.en,"otime",g)}/></Col>
                                            <Col style={{border:  "1px solid lightgray"}}>Close <TimePicker  defaultValue={'8:00'} value={x.ctime} onChange={g => changetime(x.day.en, "ctime",g)}/></Col>
                                            </Row>
                                         )
                                    })}
                   
                            </CardBody>
                        </Card>

                        <Card>
                            <CardHeader><h6>Sites {' '}<Badge onClick={t => changetimets()} color="primary">Offices</Badge>  
                            <i className="fa fa-floppy-o fa-2x" style={{float : "right", paddingRight : 20, cursor : "pointer"}} aria-hidden="true" onClick={o => savedata("SITES")}></i>
                            <i className="fa fa-address-card-o fa-2x" aria-hidden="true" style={{float : "right", paddingRight : 20, cursor : "pointer"}} onClick={o => setShowSite(true)}></i>
                            </h6>

                            </CardHeader>
                            <CardBody>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>Name </th>
                                            <th>Phone </th>
                                            <th>Address</th>
                                            <th>Area</th>
                                            <th>City</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {tenant?.sites?.map((x , key) => {
                                        return(
                                        <tr key = {key}>
                                            <td>{x?.en} {' '} {x?.ar}</td>
                                            <td>{x?.sitephn}</td>
                                            <td>{x?.siteSa}</td>
                                            <td>{x?.areas?.en}</td>
                                            <td>{x?.city?.en}</td>
                                            <td><span style={{color : "red", cursor : "pointer"}} onClick={i => delsite(x)}>X</span></td>
                                        </tr>
                                        )
                                    })}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
 

                        <Card>
                            <CardHeader><h6>Payment Mode Acceptable
                              <i className="fa fa-floppy-o fa-2x" style={{float : "right", paddingRight : 20, cursor : "pointer"}} aria-hidden="true"  onClick={o => savedata("PM")}></i></h6></CardHeader>
                            <CardBody>
                                <Row>
                                    {tenant.paymentmodes.map((x, key) => {
                                        return(
                                            <Col key={key}>{x.modename.en} {' '}
                                             <Switch 
                                                    offColor="primary"
                                                    offText="No"
                                                    onColor="primary"
                                                    onText="Yes"
                                                    onChange = {g =>  changepaymode(x)}
                                                    value={x.modename.isval}
                                                />
                                            </Col>
                                        )
                                    })}
                                </Row>
                            </CardBody>
                        </Card>
                      
                        <Card>
                            <CardHeader><h6>Delivery Areas {' '} <i className="fa fa-external-link" aria-hidden="true" onClick={g => {setShstore(true)}}></i>  <i className="fa fa-floppy-o fa-2x" style={{float : "right", paddingRight : 20, cursor : "pointer"}} aria-hidden="true" onClick={f => {savedata("DA")}} ></i></h6></CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md="11">
                                        {disarea}
                                    </Col>
                                    <Col md="1"><Badge color="danger" style={{cursor : "pointer"}} onClick={o =>cleararea()}>X</Badge></Col>
                                </Row>
                              
                            </CardBody>
                        </Card>
                    </Col>
    
                </Row>
            </div>
        );
    
}
export default connect(null, {profileFetch} )(Disclaimer);
